const EMAIL_IN_TEXT = /[^\s@]+@[a-z0-9-]+(?:\.[a-z0-9-]+)+/i;

export interface EmailSuggestion {
    suggestion: string;
    before: string;
    after: string;
}

// The backend phrases "Meintest du max@gmail.com?" per locale, so only the address inside is relied on
export const findEmailSuggestion = (message: unknown, value: unknown): EmailSuggestion | null => {
    if (typeof message !== 'string' || typeof value !== 'string') return null;

    const at = value.lastIndexOf('@');
    if (at < 1) return null;

    const match = EMAIL_IN_TEXT.exec(message);
    if (!match) return null;

    const domain = match[0].slice(match[0].lastIndexOf('@') + 1).toLowerCase();
    if (domain === value.slice(at + 1).trim().toLowerCase()) return null;

    return {
        suggestion: `${value.slice(0, at).trim()}@${domain}`,
        before: message.slice(0, match.index),
        after: message.slice(match.index + match[0].length)
    };
};
